import { render } from "./MainHeaderGroupOrgPopup.vue?vue&type=template&id=2a8f5cc2&scoped=true"
import script from "./MainHeaderGroupOrgPopup.vue?vue&type=script&lang=js"
export * from "./MainHeaderGroupOrgPopup.vue?vue&type=script&lang=js"

import "./MainHeaderGroupOrgPopup.vue?vue&type=style&index=0&id=2a8f5cc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f5cc2"]])

export default __exports__